import IconsExperiment from './IconsExperiment';
import loadable from '@loadable/component';

const HobbyIconV3 = loadable(() => import('./HobbyIconV3'));

const HobbyIconExperiment = (props) => {
  return <IconsExperiment iconV3={<HobbyIconV3 {...props} />} />;
};

HobbyIconExperiment.displayName = 'HobbyIconExperiment';

export default HobbyIconExperiment;
